import React from 'react';
import styled, { useTheme } from 'styled-components';
import Icon from 'components/Icon';
import { usePrintCashReport } from 'hooks/usePrintCashReport';
import { usePrintManager } from 'hooks/usePrintManager';
import { useCart } from 'shared/CartContext';

const PrintIcon = styled.div`
  cursor: pointer;
  margin-right: 15px;

  /* Zoom on scroll */
  transform: scale(1);
  transition: transform 0.3s ease;
  &:hover {
    transform: ${(props) => (props.disabled ? 'none' : 'scale(1.1)')};
  }

  /* Handle disabled prop */
`;

const PrintCashDrawerReport = ({ cashDrawerReport, setIsPrinting }) => {
  const { printReport } = usePrintCashReport();
  const theme = useTheme();

  const { setCurrentStatus } = useCart();

  const { connect, isConnected } = usePrintManager(); // Use the new hook

  const IPAddress = localStorage.getItem('readerIp');

  const connectPrinter = async () => {
    // Print the tickets
    if (IPAddress) {
      setIsPrinting(true);
      setCurrentStatus('Connecting to printer...');
      const connectedPrinter = isConnected();

      if (!connectedPrinter && IPAddress) {
        try {
          const connected = await connect(
            IPAddress,
            setCurrentStatus,
            setIsPrinting
          );

          if (connected) {
            onPrint();
          } else {
            console.error('Failed to connect to printer');
          }
        } catch (error) {
          console.error('Failed to connect to printer:', error);
        }
      }
    }
  };

  const onPrint = () => {
    printReport({ cashDrawerReport, setIsPrinting: setIsPrinting });
  };

  return (
    <PrintIcon
      onClick={isConnected() ? onPrint : connectPrinter}
      disabled={!IPAddress}
    >
      <Icon
        icon="Print-Icon"
        size={45}
        color={!IPAddress ? '#ccc' : theme.colors.primary}
      />
    </PrintIcon>
  );
};

export default PrintCashDrawerReport;
